module.exports = __webpack_public_path__ + "static/p3-f732a8c07515481994ade8268795009b.jpg";